// @flow

import React from "react";

import Checkbox from "src/components/Unifize/PicklistCheckbox";

import { DisplayContainer, Display } from "./styles";

type Props = {
  disabled: boolean,
  isChecked: boolean,
  isMandatory: boolean,
  handleChange: Function,
};

const CheckboxPicklist = ({
  disabled,
  isChecked,
  isMandatory,
  handleChange,
}: Props) => {
  return (
    <DisplayContainer
      data-cy="checklist-checkbox-container"
      isText={false}
      locked={disabled}
      onClick={() => {
        if (!disabled) {
          handleChange(!isChecked);
        }
      }}
      noBottomMargin={true}
    >
      <Display
        data-cy="checklist-checkbox-display"
        clickToEdit={true}
        disabled={disabled}
        isText={false}
        isCheckbox={true}
      >
        <Checkbox
          data-cy="checklist-checkbox-input"
          align="top"
          checked={isChecked}
          onChange={handleChange}
          isDisabled={disabled}
          isMandatory={isMandatory}
          height="100%"
        />
      </Display>
    </DisplayContainer>
  );
};

export default CheckboxPicklist;
